<div class="payment-result-page">

  <div class="payment-result-card">

    <div class="success-icon">
      ✓
    </div>

    <div class="brand">
      Smee<span>&amp;</span>Ford
    </div>

    <div class="red-line"></div>

    <h1>Payment successful</h1>

    <p class="intro">
      Thank you. Your PAYG payment has been successfully completed.
    </p>

    <div class="message-box">
      You will shortly receive an email with details of your bequest and attached copies of the corresponding Will and Grant of Probate documents
    </div>

    <button mat-raised-button
            color="primary"
            class="continue-button"
            (click)="goToPayg()">
      Return to PAYG
    </button>

    <p class="help-text">
      If you have any questions about your purchase, please contact
      the Smee &amp; Ford customer-services team.
    </p>

  </div>

</div>
